// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"0a1095f0","631":"865b1eba","774":"5c57dbbc","820":"11977114","851":"0752eb55","858":"2b90f9df"}[chunkId] + ".chunk.js";
};